import { toString } from 'lodash';

export function isJsonString(str) {
  try {
    const obj = JSON.parse(str);
    if (obj && typeof obj === 'object' && obj !== null) {
      return true;
    }
  } catch (err) {
    return false;
  }
  return false;
}

export function locationOrigin() {
  const { location } = window;
  const port = location.port ? `:${location.port}` : '';
  window.location.origin = `${location.protocol}//${location.hostname}${port}`;
}

export const urlHostBuilder = (domainName = '') => (serverName = '') => {
  return `${serverName}.${domainName}`;
};

export function setPaddingLeftZero(value, length) {
  let str = '';
  if (toString(value).length >= length) {
    str = value;
  } else {
    str = setPaddingLeftZero(`0${value}`, length);
  }
  return str;
}

export function parseCompanyStyle(backgroundColor, fontColor) {
  const style = {
    background: backgroundColor,
    color: fontColor,
  };
  return style;
}

export function processDate(value) {
  // 後端預設值
  const DEFAULT_DATE = '0001-01-01T00:00:00+00:00';
  return value === DEFAULT_DATE ? null : value;
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/utils/index.js
 **/